import { useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable';

export const usePdfViewer = ({
    setHasSeenAllPages
}: {
    setHasSeenAllPages: React.Dispatch<React.SetStateAction<boolean>> | ((hasSeenAllPages: boolean) => void);
}) => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [numPages, setNumPages] = useState<number>(0);
    const [seenPages, setSeenPages] = useState<Array<number>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [canPan, setCanPan] = useState<boolean>(false);
    const handlers = useSwipeable({
        preventScrollOnSwipe: true,
        trackMouse: false
    });

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
        setIsLoading(false);
    };

    const onItemClick = ({ pageNumber }: { pageIndex: number; pageNumber: number }) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        setSeenPages((prev: Array<number>) => {
            const uniquePages = [...prev, currentPage];
            const uniquePagesSet = new Set(uniquePages);
            return Array.from(uniquePagesSet);
        });
    }, [currentPage]);

    useEffect(() => {
        if (numPages && seenPages.length === numPages) {
            setHasSeenAllPages(true);
        }
    }, [seenPages, numPages, setHasSeenAllPages]);

    return {
        currentPage,
        numPages,
        setCurrentPage,
        onDocumentLoadSuccess,
        isLoading,
        handlers,
        onItemClick,
        canPan,
        setCanPan
    };
};
